import { UsersModule } from './users/users.module';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import {
    NbAuthComponent,
    // NbResetPasswordComponent,
} from '@nebular/auth';

import { HmAssistenzaComponent } from './hm-auth/hm-assistenza/hm-assistenza-component';
import { HmLoginComponent } from './hm-auth/hm-login/hm-login-component';
import { HmLogoutComponent } from './hm-auth/hm-logout/hm-logout-component';
import { HmRequestPasswordComponent } from './hm-auth/hm-request-password/hm-request-password-component';
import { HmResetPasswordComponent } from './hm-auth/hm-reset-password/hm-reset-password-component';
import { AdminAuthGuard } from './admin/admin-auth-guard';
import { UsersAuthGuard } from './users/users-auth-guard';
import { MoodleAuthComponent } from './hm-auth/moodle-auth/moodle-auth.component';

import { AssistenzaFaqOperatoriComponent } from './shared/assistenza-faq-operatori/assistenza-faq-operatori.component';
import { HmUpdateProfileComponent } from './hm-auth/hm-update-profile/hm-update-profile.component';

const routes: Routes = [
    {
        path: 'auth',
        component: NbAuthComponent,
        children: [
            {
                path: '',
                component: HmLoginComponent,
                pathMatch: 'full',
            },
            {
                path: 'login',
                component: HmLoginComponent,
            },
            /*{
              path: 'register',
              component: NbRegisterComponent,
            },*/
            {
                path: 'logout',
                component: HmLogoutComponent,
            },
            {
                path: 'request-password',
                component: HmRequestPasswordComponent,
            },
            {
                path: 'reset-password',
                component: HmResetPasswordComponent,
            },
            {
                path: 'assistenza',
                component: HmAssistenzaComponent,
            },
            {
                path: 'can_online',
                component: MoodleAuthComponent,
            },
            {
                path: 'faq',
                component: AssistenzaFaqOperatoriComponent,
            },
            {
                path: 'update-profile',
                component: HmUpdateProfileComponent,
            },

        ],
    },
    {
        path: 'admin', loadChildren: () => import('@hm_app/admin/admin.module')
            .then(m => m.AdminModule), runGuardsAndResolvers: 'always',
        canActivate: [AdminAuthGuard],
    },
    {
        path: 'users', loadChildren: () => import('@hm_app/users/users.module')
            .then(m => m.UsersModule), runGuardsAndResolvers: 'always',
        canActivate: [UsersAuthGuard],
    },

    {
        path: 'public', loadChildren: () => import('@hm_app/public/public.module')
            .then(m => m.PublicModule), runGuardsAndResolvers: 'always',
    },
    {
        path: 'spagent', loadChildren: () => import('@hm_app/spagent/spagent.module')
            .then(m => m.SpagentModule), runGuardsAndResolvers: 'always',
    },
    { path: '', redirectTo: 'admin', pathMatch: 'full' },
    { path: '**', redirectTo: 'admin' },
];

const config: ExtraOptions = {
    useHash: true,
    onSameUrlNavigation: 'reload',
    // enableTracing: true,
};



@NgModule({
    imports: [RouterModule.forRoot(routes, config)],
    exports: [RouterModule],
})
export class AppRoutingModule { }

